// removed by extract-text-webpack-plugin
module.exports = {"logo":"styles__logo__2FngQ","header":"styles__header__upe80","responsiveNavWidth":"styles__responsiveNavWidth__3dkWa","scrolling":"styles__scrolling__14G3N","brand":"styles__brand__7uh_C","designForCue":"styles__designForCue__2X54c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/styles.scss
// module id = 398
// module chunks = 0